// ======================================================================
// FILE:
// src/modules/finance/components/FinancePageHeader.jsx
//
// MODULE:
// Finance & Accounts Management System (FBAMS)
//
// COMPONENT:
// Finance Page Header
//
// PURPOSE:
// Reusable page header for all Finance screens.
//
// FEATURES:
// - Responsive layout
// - FontAwesome icon
// - Title
// - Subtitle
// - Breadcrumb
// - Right information area
// - Action buttons
// - Mobile friendly
//
// AUTHOR:
// DizyPro ERP
// ======================================================================

import React from "react";
import { Link } from "react-router-dom";

// ======================================================================
// COMPONENT
// ======================================================================

export default function FinancePageHeader({

    icon,

    title,

    subtitle,

    breadcrumbs = [],

    rightContent = null,

    actions = null,

}) {

    return (

        <div className="card shadow-sm border-0 mb-4">

            <div className="card-body">

                <div className="row align-items-start">

                    {/* ======================================================
                        LEFT
                    ====================================================== */}

                    <div className="col-lg-8 col-md-7 col-12">

                        <div className="d-flex align-items-start">

                            <div
                                className="me-3 mt-1"
                                style={{
                                    width: 54,
                                    height: 54,
                                    borderRadius: 12,
                                    background: "#0d6efd",
                                    color: "#fff",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: 22,
                                }}
                            >
                                <i className={icon} />
                            </div>

                            <div>

                                <h3
                                    className="fw-bold mb-1"
                                >
                                    {title}
                                </h3>

                                {
                                    subtitle &&
                                    (
                                        <div className="text-muted mb-2">
                                            {subtitle}
                                        </div>
                                    )
                                }

                                {
                                    breadcrumbs.length > 0 && (

                                        <nav>

                                            <ol
                                                className="breadcrumb mb-0"
                                                style={{
                                                    fontSize: 13,
                                                }}
                                            >

                                                {
                                                    breadcrumbs.map(
                                                        (
                                                            item,
                                                            index
                                                        ) => (

                                                            <li
                                                                key={index}
                                                                className={
                                                                    `breadcrumb-item ${
                                                                        index ===
                                                                        breadcrumbs.length - 1
                                                                            ? "active"
                                                                            : ""
                                                                    }`
                                                                }
                                                            >

                                                                {
                                                                    item.to ? (

                                                                        <Link
                                                                            to={
                                                                                item.to
                                                                            }
                                                                        >
                                                                            {
                                                                                item.label
                                                                            }
                                                                        </Link>

                                                                    ) : (

                                                                        item.label

                                                                    )
                                                                }

                                                            </li>

                                                        )
                                                    )
                                                }

                                            </ol>

                                        </nav>

                                    )
                                }

                            </div>

                        </div>

                    </div>

                    {/* ======================================================
                        RIGHT
                    ====================================================== */}

                    <div className="col-lg-4 col-md-5 col-12 mt-3 mt-md-0">

                        <div className="d-flex flex-column align-items-md-end">

                            {
                                rightContent &&
                                (
                                    <div className="mb-3 w-100">

                                        {rightContent}

                                    </div>
                                )
                            }

                            {
                                actions &&
                                (
                                    <div
                                        className="
                                            d-flex
                                            flex-wrap
                                            justify-content-md-end
                                            gap-2
                                        "
                                    >

                                        {actions}

                                    </div>
                                )
                            }

                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}